<template>
  <v-card>
    <v-card-title>Autopsy statistics</v-card-title>
    <!-- <v-card-text>Explanation of the graph?</v-card-text> -->
    <v-card-text class="text-center">
      <doughnut-chart v-if="autopsyloaded" :chartData="chartdata" :options="options" />
      <template v-else >
        <p>Loading data from server...</p>
        <v-progress-circular indeterminate size="100"/>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { get } from "vuex-pathify";
import DoughnutChart from "@/charts/DoughnutChart.vue"

export default {
  name: "Autopsy",
  components: { DoughnutChart },
  data: function () {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        // scales: {
        //   xAxes: [{
        //     stacked: true
        //   }],
        //   yAxes: [{
        //     stacked: true
        //   }]
        // }
      },
      chartdata: {
        labels: [],
        datasets: [],
      },
    };
  },
  async mounted() {
    await new Promise((resolve) => setTimeout(resolve, 400));
    this.fillData();
  },
  computed: {
    ...get("chart", ["autopsy", "autopsyloaded"]),
  },
  methods: {
    fillData() {
      this.chartdata = {
        type: 'doughnut',
        labels: this.autopsy.labels,
        datasets: [
          {
            label: 'check what is this?',
            data: this.autopsy.series,
            // both - none - not applicable - only autopsy - only toxicol analysis - unknown
            backgroundColor: [ '#ffba31','#404564','red', '#28afbb', '#056dac', '#dedef4']
          },
        ] 
      }
    },
  },
};
</script>
